// extracted by mini-css-extract-plugin
module.exports = {"Btn":"Buttons_Btn__1GG4w","Answer":"Buttons_Answer__2k-16","Big":"Buttons_Big__2a8vL","Config":"Buttons_Config__2sVv-","Small":"Buttons_Small__3v3Dg","Wide":"Buttons_Wide__1YmKm"};